import React from "react";
import _ from "underscore";

import {Link} from "react-router";

import FormatListNumberedIcon from "@material-ui/icons/FormatListNumbered";
import {List, ListItem} from "material-ui/List";

import NavItem from "routes/logged_in/components/sidebar/nav_item";
import SidebarPanel from "routes/logged_in/components/sidebar/panel";

import isSectionInSelectedGroup from "../../../../utils/is_section_in_selected_group";
import isLlmIssueWithNullMeta from "utils/issues/is_llm_issue_with_null_meta";
import {MatterTreeView} from "common_components/matter";
import {ArrowBack} from "@material-ui/icons";

const styles = {
  list: {
    padding: 10,
    flexGrow: 1,
    overflowX: "hidden",
    overflowY: "auto",
  },
  mainContentItem: {
    padding: 0,
  },
  listItem: {
    paddingLeft: "3px",
    paddingRight: "3px",
    paddingTop: "3px",
    paddingBottom: "3px",
    fontSize: "13px",
    fontWeight: 100,
  },
  text: {
    overflow: "hidden",
    whiteSpace: "nowrap",
    textOverflow: "ellipsis",
  },
  divider: {
    height: "1px",
    backgroundColor: "#e0e0e0",
    margin: "12px 0",
    width: "100%",
  },
  matterTreeContainer: {
    overflowY: "auto",
  },
};

styles.sectionListItem = {
  ...styles.listItem,
  fontWeight: 400,
  textAlign: "center",
  textTransform: "uppercase",
};

export default class ContentItem extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      lastChecklistId: null,
    };
  }

  componentDidMount() {
    const isMatterDocument = this.props.router?.location?.pathname?.includes(
      "/matter/",
    );
    if (isMatterDocument && this.props.showSidebarPanel && this.navItemRef) {
      this.props.showSidebarPanel(this.navItemRef);
    }

    const currentChecklistId = new URLSearchParams(
      this.props.router?.location?.search,
    ).get("checklist_document_id");
    this.setState({lastChecklistId: currentChecklistId});
  }

  componentDidUpdate() {
    // re-open sidebar when checklist_document_id changes
    const currentChecklistId = new URLSearchParams(
      this.props.router?.location?.search,
    ).get("checklist_document_id");

    if (
      this.state.lastChecklistId !== currentChecklistId &&
      currentChecklistId
    ) {
      const isMatterDocument = this.props.router?.location?.pathname?.includes(
        "/matter/",
      );

      if (isMatterDocument && this.props.showSidebarPanel && this.navItemRef) {
        setTimeout(() => {
          this.props.showSidebarPanel(this.navItemRef);
        }, 0);
      }
      this.setState({lastChecklistId: currentChecklistId});
    }
  }

  handleMatterDocumentSelect = document => {
    const {organisationId, projectId, matterId} = this.props.params;
    const path = `/organisation/${organisationId}/project/${projectId}/matter/${matterId}/document/${document.id}`;
    this.props.router.push(path);
  };

  handleChecklistDocumentSelect = documentId => {
    const currentPath = this.props.router.location.pathname;
    const queryString = `?checklist_document_id=${documentId}`;
    const newPath = `${currentPath}${queryString}`;
    this.props.router.replace(newPath);
  };

  getChecklistDocumentIdFromUrl = () => {
    const search = this.props.router?.location?.search;
    if (!search) {
      return undefined;
    }

    const params = new URLSearchParams(search);
    const checklistDocId = params.get("checklist_document_id");
    return checklistDocId ? parseInt(checklistDocId, 10) : undefined;
  };

  render() {
    const hasMatterData = this.props.matter && this.props.matter.documents;

    const selectedDocumentId = parseInt(this.props.params.documentId, 10);
    const selectedDocument = hasMatterData
      ? this.props.matter.documents.find(doc => doc.id === selectedDocumentId)
      : null;
    const isViewingMSA = selectedDocument?.document_type_id === 1;

    const contents = this.props.documentSections
      .filter(section => !section.is_hidden)
      .map(section => {
        const isSectionSelected =
          this.props.selectedChecklistSectionId &&
          isSectionInSelectedGroup(
            section.id,
            this.props.selectedChecklistSectionId,
            this.props.checklistSections,
          );

        const backgroundStyle = this.props.selectedChecklistSectionId
          ? isSectionSelected
            ? {}
            : {background: "#eeeeee"}
          : {};
        const headings = this.props.documentHeadings.filter(
          heading => heading.section_id === section.id,
        );
        if (headings.length === 0) {
          return null;
        }
        const onSectionScroll = () => {
          this.props.scrollToSection(section);
        };
        const sectionHeading = (
          <SelectableListItem
            innerDivStyle={{
              ...styles.sectionListItem,
              ...backgroundStyle,
            }}
            key={section.id}
            primaryText={
              section.name
                ? `${section.reference} - ${section.name}`
                : section.reference
            }
            onClick={onSectionScroll}
          />
        );
        const clauseHeadings = headings.map(heading => {
          const text = headingText(heading);

          const onHeadingScroll = () => {
            this.props.scrollToHeading(heading);
          };
          return (
            <SelectableListItem
              className="list-item"
              innerDivStyle={{
                ...styles.listItem,
                ...backgroundStyle,
              }}
              key={heading.id}
              primaryText={<div style={styles.text}>{text}</div>}
              onClick={onHeadingScroll}
              selected={heading.reference === this.props.selectedHeading}
              visible={_.find(
                this.props.headingVisibility[heading.fullReference],
                view => view.isVisible,
              )}
              collapsed={this.props.hiddenHeadings[heading.reference]}
            />
          );
        });
        return [sectionHeading, ...clauseHeadings];
      });

    return (
      <NavItem
        ref={ref => (this.navItemRef = ref)}
        isCollapsed={true}
        icon={<FormatListNumberedIcon />}
        collapsedTitle={"Table of Contents"}
        panelChildren={
          <SidebarPanel headerText="Contents">
            {hasMatterData && (
              <>
                <Link
                  style={{textDecoration: "none", color: "inherit"}}
                  to={`/organisation/${this.props.organisationId}/project/${this.props.projectId}/matter/${this.props.matter.id}`}
                >
                  <div
                    style={{
                      hover: "cursor",
                      display: "flex",
                      alignItems: "center",
                      gap: "0.5em",
                      padding: "8px",
                    }}
                  >
                    <ArrowBack />
                    <span>{this.props.matter.config.name}</span>
                  </div>
                </Link>
                <div style={styles.matterTreeContainer}>
                  <MatterTreeView
                    matterData={this.props.matter}
                    selectedDocumentId={selectedDocumentId}
                    onNodeSelect={this.handleMatterDocumentSelect}
                    displayInDocDetail={true}
                    checklistDocumentId={this.getChecklistDocumentIdFromUrl()}
                    onChecklistDocumentSelect={
                      isViewingMSA &&
                      this.props.document?.issues?.every(isLlmIssueWithNullMeta)
                        ? this.handleChecklistDocumentSelect
                        : undefined
                    }
                    isViewingMSA={isViewingMSA}
                    secondaryDocumentLoading={
                      this.props.secondaryDocumentLoading
                    }
                  />
                </div>
                <div style={styles.divider} />
              </>
            )}

            <List
              style={{
                ...styles.list,
                ...(hasMatterData ? {maxHeight: "50%"} : {}),
              }}
            >
              {_.flatten(contents)}
            </List>
          </SidebarPanel>
        }
      />
    );
  }
}

ContentItem.Icon = FormatListNumberedIcon;

class SelectableListItem extends React.Component {
  render() {
    const {selected, visible, collapsed} = this.props;
    return (
      <ListItem
        {..._.omit(this.props, "visible", "collapsed")}
        style={this.determineStyle(selected, visible, this.props.style)}
        innerDivStyle={this.determineInnerStyle(
          selected,
          visible,
          collapsed,
          this.props.innerDivStyle,
        )}
      />
    );
  }

  determineStyle = _.memoize(
    (selected, visible, style) => ({
      ...(style || {}),
      ...(selected ? {backgroundColor: "red"} : {}),
    }),
    (...args) => JSON.stringify([...args]),
  );

  determineInnerStyle = _.memoize(
    (selected, visible, collapsed, style) => ({
      ...(style || {}),
      ...(visible ? {fontWeight: 400} : {}),
      ...(collapsed ? {color: "#999"} : {}),
    }),
    (...args) => JSON.stringify([...args]),
  );
}

function headingText(heading) {
  return [
    heading.prefixCounter ? `${heading.prefixCounter}.` : "",
    " ",
    heading.text.charAt(0).toUpperCase(),
    heading.text.substring(1).toLowerCase(),
  ].join("");
}
